const photoOverlayDirectionMap = {
  "bottom-top": "0deg",
  "top-bottom": "180deg",
  "left-right": "90deg",
  "right-left": "270deg",
  tint: ""
};

export { photoOverlayDirectionMap };
